import { useMemo } from 'react';

import { useBookings } from '@/features/bookings/useBookings';
import { useT } from '@/i18n';
import { BookingsPanel } from './BookingsListModal';

/**
 * F5-R8a · «Mi agenda» del agente (dibujo «Agente v2 — Header», pestaña
 * Mi agenda: «2 citas hoy · 5 esta semana.»). El contenido VIVO de
 * BookingsListModal — tabs de rango, búsqueda, historial A-14, detalle con
 * start/reschedule/notas y el creador inline — montado como página
 * (BookingsPanel, extraído sin tocar su lógica). Lo vivo manda: cero
 * endpoints nuevos, cero flujos nuevos.
 *
 * El subtítulo es dato vivo: citas VIVAS de hoy (scheduled/rescheduled)
 * y de la semana, sobre las MISMAS queryKeys ['bookings.me', ...].
 */
export function AgendaPage(): JSX.Element {
  const t = useT();
  const todayQ = useBookings('today');
  const weekQ = useBookings('week');

  const liveCount = (rows: Array<{ status: string }> | undefined): number =>
    (rows ?? []).filter((b) => b.status === 'scheduled' || b.status === 'rescheduled').length;

  const todayCount = useMemo(() => liveCount(todayQ.data), [todayQ.data]);
  const weekCount = useMemo(() => liveCount(weekQ.data), [weekQ.data]);

  return (
    <div className="max-w-[1080px] mx-auto font-body text-nav-navy">
      {/* Cabecera — pageCopy del dibujo, con el dato vivo. */}
      <header className="animate-fade-up-slow mb-4">
        <h1 className="font-head text-2xl font-extrabold tracking-[-0.02em] m-0">
          {t('agentF5.r8a.tabAgenda')}
        </h1>
        <p className="text-sm text-nav-slate mt-1 m-0" aria-live="polite">
          {todayQ.isLoading || weekQ.isLoading
            ? '…'
            : t('agentF5.r8a.agendaSub', { n: todayCount, w: weekCount })}
        </p>
      </header>

      {/* F5-R9g — el wrapper SE CONSERVA (decisión anotada): en el navigator
          las filas-tarjeta viven dentro del Scr blanco, así que acá la
          tarjeta se queda pero con la piel exacta de Scr (radio 14 + sombra
          en vez de borde) para que el panel re-vestido respire igual. */}
      <section
        className="bg-white rounded-[14px] shadow-[0_1px_2px_rgba(18,43,68,.06),0_8px_24px_rgba(18,43,68,.10)] px-6 sm:px-[30px] pt-[26px] pb-8 animate-fade-up-slow"
        style={{ animationDelay: '60ms' }}
      >
        <BookingsPanel />
      </section>
    </div>
  );
}
